export default "__VITE_ASSET__fYrz9DPN__"